<template>
  <div  class="main-content" id="home" :style="{backgroundImage: 'url(' + img + ')' }">
    <div class="head" id="head">
      <div class="logo">
        <img :src="logo">
      </div>

      <ul class="linkFont">
<!--        <li>首页</li>-->
        <li><a href="#" @click="toLink(817)">平台介绍</a></li>
        <li><a href="#" @click="toLink(1624)">功能服务</a></li>
        <li><a href="#" @click="toLink(2252)">优势特点</a></li>
        <li><a href="#" @click="toLink(2920)">合作伙伴</a></li>
        <li><a href="#" @click="toLink(3204)">联系我们</a></li>
      </ul>
    </div>

<!--    挖掘设备后市场潜能-->
    <div class="contain" style="top: 325.9px">
      <div class="MainTitle">
        <img :src="MainTitle" id="MainTitle">
      </div>
    </div>

    <div class="contain" style="top:650px">
        <img :src="mainWhite">
    </div>


    <div class="oval">
      <div class="oval7"></div>
      <div class="oval6"></div>
      <div class="oval5"></div>
    </div>

  </div>
</template>

<script>
    import bgImg from '@/assets/index/img/BG.png'
  import mainWhite from '@/assets/index/img/mainWhite.png'
  import MainTitle from '@/assets/index/img/MainTitle.png'
  import logo from '@/assets/index/img/鼎研科技文字LOGO.png'
export default {
    data(){
      return{
            img:bgImg,
            mainWhite:mainWhite,
            MainTitle:MainTitle,
            logo:logo,
            defaultTop: 100,
            scrollTop:100,
            defaultDuration: 400,
            width:0
      }
    },
    created(){
        this.width=document.body.clientWidth
    },
    mounted(){
        window.addEventListener('resize', this.handelWidth, false)
        this.handelWidth()
    },
    beforeDestroy(){
        window.removeEventListener("resize",this.handelWidth, false)
    },
    methods:{
          //定位到相应的位置
          toLink(position){
                window.requestAnimationFrame = (function(){
                  return  window.requestAnimationFrame       ||
                          window.webkitRequestAnimationFrame ||
                          window.mozRequestAnimationFrame    ||
                          function( callback ){
                            window.setTimeout(callback, 1000 / 60);
                          };
                })();
                var step =  position / (this.defaultDuration / ( 1000 / 60)) >> 0;
                // var self = this
                let index=0;
                function fn(){
                  if(index <= position){
                    index += step;
                    document.documentElement.scrollTop = document.body.scrollTop = index;
                    fn.rafTimer = requestAnimationFrame(fn);
                  }else{
                    document.body.scrollTop = 0;
                    cancelAnimationFrame(fn.rafTimer);
                  }
                }
                fn.rafTimer = requestAnimationFrame(fn)
                return false;
          },
        //监听浏览器宽度
        handelWidth(){
            this.width=document.body.clientWidth
            let w=document.body.clientWidth
            let MainTitle=document.getElementById("MainTitle")
            let head=document.getElementById("head")
            if(w>=1000){
                MainTitle.style.width="900.8px"
            }else if (w<1000){
                MainTitle.style.width="700px"
            }
            if (w>=940){
                head.style.paddingLeft="15%"
            }else {
                head.style.paddingLeft="10%"
            }
        }

    }
}
</script>

<style>
  ul {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    float: right;
    flex-flow: row nowrap;
    justify-content: center;
  }
  ul li {
    list-style: none;
    padding-left: 19px;
    padding-right: 19px;
    padding-top: 9px;
    margin: 0 10px;
  }
  .linkFont a {
    color: #ffffff;
    text-decoration:none
  }
  .linkFont a:hover {
    color: #ffffff;
    text-decoration:none
  }

  .head{
    width: 100%;
    position: absolute;
    top: 15px;
    padding-left:15% ;
    padding-right: 10%;
  }

  .logo{
    position: inherit;
    float: left;
  }
  .linkFont{
    height:22px;
    font-size:16px;
    font-family:Alibaba PuHuiTi;
    font-weight:400;
    line-height:22px;
    color:rgba(255,255,255,1);
    opacity:1;
  }


  .contain{
    position: absolute;
    width: 100%;
  }
  .MainTitle{
    position: relative;
    margin: 0 auto;
  }



  .oval{
    position: relative;
    top: 726px;
    width: 100%;
  }
  .oval7{
    width:8px;
    height:8px;
    background:rgba(255,255,255,1);
    border-radius:50%;
    opacity:1;
    position: relative;
    margin: 0 auto;
  }
  .oval6{
    width:6px;
    height:6px;
    background:rgba(255,255,255,1);
    border-radius:50%;
    opacity:1;
    position: relative;
    margin: 17px auto;
  }
  .oval5{
    width:4px;
    height:4px;
    background:rgba(255,255,255,1);
    border-radius:50%;
    opacity:1;
    position: relative;
    margin: 17px auto;
  }

</style>
